<template>
  <div class="report-item">
    <van-image class="image" fit="cover" :src="item.pic | firstImgThumb" />
    <div class="text-info">
      <div class="text-info-item">
        <span class="label">颁证名称:</span> <span class="content">{{ item.reportName }}</span>
      </div>
      <div class="text-info-item">
        <span class="label">颁证机构:</span> <span class="content">{{ item.certificationCompany }}</span>
      </div>
      <div class="text-info-item">
        <span class="label">颁证编号:</span> <span class="content">{{ item.seriesNo }}</span>
      </div>
      <div class="text-info-item">
        <span class="label">颁证日期:</span> <span class="content">{{ formatTime(item.certificateDate, 'YYYY-MM-DD') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTime } from '@/utils/convert/convertTime'
import { firstImgThumb } from '@/filter'
export default {
  name: 'TestReportListItem',
  filters: {
    firstImgThumb
  },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    formatTime
  }
}
</script>

<style lang='less' scoped>

.report-item {
  font-family: Microsoft YaHei;
  .image {
    height: 80px;
    width: 80px;
    flex-shrink: 0;
  }
  .image,
  .text-info {
    display: inline-block;
  }
  .text-info {
    margin-left: 14px;
  }
  .text-info-item + .text-info-item {
    margin-top: 5px;
  }
  .text-info-item {
    width: 100%;
    font-size: 12px;
    font-weight: 400;
    color: #323332;
    display: flex;
    .label {
      word-break: keep-all;
      white-space: nowrap;
    }
    .content {
      word-break: break-all;
      width: 100%;
      margin-left: 1em;
    }
  }
}
</style>
